/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */ // TODO: add props
import { FAILURE_REASON } from 'edrolo/domains/net/constants';
import style from './Failure.scss';

const showChatWindow = () => window.zE('webWidget', 'open');

const UnauthorizedFailure = () => (
  <div className={style.failureContainer}>
    <div className={style.imageContainer}>
      <img src={`${global.__static__}img/chunkview/camerahead.png`} />
    </div>
    <div className={style.failureContent}>
      <h1 className={style.mainHeading}>What are you doing here?</h1>
      <h2 className={style.subHeading}>
        It appears that you’re trying to access resources that aren’t meant for
        you.
      </h2>
      <p>
        If this sounds like a mistake, please{' '}
        <a onClick={showChatWindow}>
          get in touch with our friendly support team
        </a>{' '}
        right away!
      </p>
    </div>
  </div>
);

const SystemFailure = () => (
  <div className={style.failureContainer}>
    <div className={style.imageContainer}>
      <img src={`${global.__static__}img/chunkview/camerahead.png`} />
    </div>
    <div className={style.failureContent}>
      <h1 className={style.mainHeading}>Oh fiddlesticks!</h1>
      <h2 className={style.subHeading}>
        Something has gone horribly wrong. It’s a technical issue and it’s
        probably our fault.
      </h2>
      <p>
        We’re truly sorry. And we’ll be looking into the problem right away.
      </p>
      <p>
        You could wait a few moments, and try again, but as always,{' '}
        <a onClick={showChatWindow}>
          get in touch with our friendly support team
        </a>{' '}
        if the issue remains.
      </p>
    </div>
  </div>
);

const NotFoundFailure = () => (
  <div className={style.failureContainer}>
    <div className={style.imageContainer}>
      <img src={`${global.__static__}img/chunkview/camerahead.png`} />
    </div>
    <div className={style.failureContent}>
      <h1 className={style.mainHeading}>Oh fiddlesticks!</h1>
      <h2 className={style.subHeading}>
        We can’t find the resources you’re looking for.
      </h2>
      <p>
        You might have clicked a broken link (sorry, our bad), or incorrectly
        entered a URL. No need to panic though &ndash; we&rsquo;ve got a few
        options.
      </p>
      <p>
        You could press the &ldquo;back&rdquo; button on your browser, or start
        from scratch at our <a href="/">homepage</a>.
      </p>
      <p>
        If you remain stuck please{' '}
        <a onClick={showChatWindow}>
          get in touch with our friendly support team
        </a>{' '}
        right away!
      </p>
    </div>
  </div>
);

const NetworkFailure = () => (
  <div className={style.failureContainer}>
    <div className={style.failureContent}>
      <h1 className={style.mainHeading}>Oh fiddlesticks!</h1>
      <h2 className={style.subHeading}>
        It seems there’s a problem with your internet connection.
      </h2>
      <p>
        Once you’ve confirmed your connection is up and running again – please
        try again!
      </p>
      <p>
        And as always,{' '}
        <a onClick={showChatWindow}>
          get in touch with our friendly support team
        </a>{' '}
        if you’ve got your internet connection working but you’re still having
        issues.
      </p>
    </div>
  </div>
);

const Failure = ({ reason }) => {
  if (reason === FAILURE_REASON.UNAUTHORIZED_ERROR) {
    return <UnauthorizedFailure />;
  }

  if (reason === FAILURE_REASON.NOT_FOUND_ERROR) {
    return <NotFoundFailure />;
  }

  if (reason === FAILURE_REASON.NETWORK_ERROR) {
    return <NetworkFailure />;
  }

  return <SystemFailure />;
};

export default Failure;
